import ReactDOM from "react-dom";
import { IoCloseSharp } from "react-icons/io5";
import { useAuth } from "../../auth/AuthContext";
import moment from "moment";
import { currencyFormatter } from "../../helpers/currencyFormatter";
import { useOutletContext } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function TransactionModal({
  passed,
  setTransactionModal,
  transaction,
}) {
  //   console.log("Transaction in the modal: ",transaction);
  const { darkMode } = useAuth();
  const [, profile, , roles] = useOutletContext();
  const navigate = useNavigate();

  return ReactDOM.createPortal(
    <div
      className={`bg-black bg-opacity-20 z-40 w-screen h-screen fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center ${
        darkMode ? "dark" : ""
      } `}
    >
      <div
        className="bg-white mx-2 dark:bg-dark-bg dark:text-secondary-text p-10 rounded-md shadow-md flex flex-col items-center"
        ref={passed}
      >
        {/* {children} */}
        <div className="flex justify-between items-center w-full mb-5">
          <div>
            <span className="font-bold text-lg">Transaction Details</span>
            {transaction?.application_meta &&
              (((roles.includes("secretary") ||
                roles.includes("asst_secretary")) &&
                transaction?.application_meta?.review_status === "pending") ||
                ((roles.includes("chairperson") ||
                  roles.includes("vice_chairperson")) &&
                  transaction?.application_meta?.review_status ===
                    "forwarded")) &&
              transaction.application_meta.applicants_id !== profile.id && (
                <button
                  className="bg-green-500 text-white outline-offset-2 px-1 rounded-sm w-22 capitalize font-normal text-base py-0.5 border ml-10"
                  onClick={() => {
                    navigate(
                      `/organisation/transactions/${transaction.application_id}`
                    );
                  }}
                >
                  Verify
                </button>
              )}
          </div>
          <div
            className="dark:hover:bg-dark-bg-600 hover:bg-accent p-2 rounded-full cursor-pointer"
            onClick={() => setTransactionModal(false)}
          >
            <IoCloseSharp />
          </div>
        </div>

        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">Date</p>
          <p className="font-bold col-span-3 pl-8">
            : {moment(transaction?.created_at).format("DD-MM-YYYY, hh:mm a")}
          </p>
        </div>

        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">Type</p>
          <p className="font-bold col-span-3 pl-8 capitalize">
            : {transaction?._type}
          </p>
        </div>

        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">Amount</p>
          <p className="font-bold col-span-3 pl-8">
            : UGX{" "}
            {currencyFormatter(
              transaction?.amount || transaction?.application_meta?.amount
            )}
          </p>
        </div>

        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">Account</p>
          <p className="font-bold col-span-3 pl-8 capitalize">
            :{" "}
            {transaction?.transaction_meta?.account_type ||
              transaction?.application_meta?.account_type}
          </p>
        </div>

        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">Transaction Type</p>
          <p className="font-bold col-span-3 pl-8 capitalize">
            :{" "}
            {transaction?.transaction_meta?.transaction_type ||
              transaction?.application_meta?.transaction_type}
          </p>
        </div>

        {transaction?._type === "withdraw" && (
          <>
            <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
              <p className="col-span-1">Reason</p>
              <p className="font-bold col-span-3 pl-8 capitalize">
                :{" "}
                {transaction?.transaction_meta?.reason ||
                  transaction?.application_meta?.reason ||
                  "Unspecified"}
              </p>
            </div>
            <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
              <p className="col-span-1">Cashout Method</p>
              <p className="font-bold col-span-3 pl-8 capitalize">
                :{" "}
                {transaction?.transaction_meta?.cashout_method ||
                  transaction?.application_meta?.cashout_method ||
                  "Unspecified"}
              </p>
            </div>
          </>
        )}

        {transaction?.application_meta?.designated_for === "other" && (
          <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
            <p className="col-span-1">Designated for</p>
            <p className="font-bold col-span-3 pl-8">
              :{" "}
              {transaction?.application_meta?.member?.member_name ||
                transaction?.transaction_meta?.member?.member_name}
            </p>
          </div>
        )}
        {transaction?.transaction_meta && (
          <>
            <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
              <p className="col-span-1">Approved at</p>
              <p className="font-bold col-span-3 pl-8">
                :{" "}
                {moment(transaction?.transaction_meta?.approved_at).format(
                  "DD-MM-YYYY, hh:mm a"
                )}
              </p>
            </div>
            <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
              <p className="col-span-1">Status</p>
              <p className="font-bold col-span-3 pl-8">
                :{" "}
                {
                  <span className="bg-green-400 py-1 px-2 rounded-xl text-white">
                    approved
                  </span>
                }
              </p>
            </div>
          </>
        )}
        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">
            {transaction?.transaction_meta ? "Approved by" : "Status"}
          </p>
          <p className="font-bold col-span-3 pl-8">
            :{" "}
            {transaction?.transaction_meta ? (
              transaction?.transaction_meta?.approved_by
            ) : (
              <span
                className={` py-1 px-2 rounded-xl text-white inline-block ${
                  transaction?.application_meta?.review_status === "pending"
                    ? "bg-yellow-400"
                    : transaction?.application_meta?.review_status ===
                      "rejected"
                    ? "bg-red-400"
                    : transaction?.application_meta?.review_status ===
                      "forwarded"
                    ? "bg-blue-400"
                    : "bg-green-400"
                }`}
              >
                {transaction?.application_meta?.review_status === "pending"
                  ? "pending approval"
                  : transaction?.transaction_meta
                  ? "approved "
                  : transaction?.application_meta?.review_status}
              </span>
            )}
          </p>
        </div>
      </div>
    </div>,
    document.getElementById("portal")
  );
}
